import { Experience } from "@app/features/workshops/types/about.interface";

export const getExperiences = (experiences: Experience[]) => {
  if (experiences) {
    return experiences.map(item => item.id.toString());
  }
  return [];
};
